angular.
module("dx.webapp.student").
controller("DxDeleteStudentsRouteController", function DxDeleteStudentsRouteController(
	$rootScope,

	dxApiV1Students,
	dxSession,
	dxDialog,
	NodeRepository,
	DX_STUDENT_SORT_PREDICATE
) {
	"use strict";

	var self = this;
	self.role = dxSession.getRole();
	self.deleteLimit = 1000;
	self.DX_STUDENT_SORT_PREDICATE = DX_STUDENT_SORT_PREDICATE;
	self.sortOptions = {
		predicate: DX_STUDENT_SORT_PREDICATE.CREATED,
		reverse: true,
	};
	self.node = null;
	self.students = [];
	self.selectedStudents = {};
	self.selectedAll = false;
	self.isDeleting = false;
	self.studentsToDelete = [];
	self.successDeletesCount = 0;
	self.rejectedDeletes = {};
	self.pageToken = null;
	self.error = null;
	self.isLoading = false;
	self.searchInput = "";
	self.selectedCount = 0;


	NodeRepository.load(self.role.organizationId).then(function onNodeLoadSuccess(node) {
		self.node = node;
	}, function onReject() {
		self.error = "failed to load organization";
	});

	function fetchDeletableStudents() {
		self.isLoading = true;
		dxApiV1Students.getDeletable({
			organizationID: self.role.organizationId,
			searchInput: self.searchInput,
			pageToken: self.pageToken,
			sortBy: self.sortOptions.reverse ? "-" + self.sortOptions.predicate : self.sortOptions.predicate,
		}).then(function success(response) {
			response.data.hits.forEach(function forEachFn(hit) {
				var student = angular.extend({}, hit.student, {highlight: hit.highlight});
				self.students.push(student);
			});
			self.pageToken = response.data.pageToken;
			self.isLoading = false;
		}, function reject(res) {
			self.error = res.data.message;
		});
		calculateSelectedCount();
	}

	self.onSelectAll = function onSelectAll() {
		if (self.selectedAll) {
			self.students.forEach(function forEachFn(student) {
				self.selectedStudents[student.id] = true;
			});
		} else {
			self.selectedStudents = {};
		}
		calculateSelectedCount();
	};

	self.onSelectStudent = function onSelectStudent(studentID) {
		self.selectedStudents[studentID] = !self.selectedStudents[studentID];

		calculateSelectedCount();
	};

	function calculateSelectedCount() {
		self.selectedCount = self.students.reduce(function reduceFn(counter, student) {
			return self.selectedStudents[student.id] ? counter + 1 : counter;
		}, 0);
	}

	self.onDeleteSelectedBtnClick = function onDeleteSelectedBtnClick() {
		self.studentsToDelete = self.students.filter(function filterFn(student) {
			return self.selectedStudents[student.id] || false;
		});
		showConfirmationDialog();
	};

	self.onTrashBtnClick = function onTrashBtnClick(event, studentID) {
		event.stopPropagation();
		event.preventDefault();
		self.studentsToDelete = self.students.filter(function filterFn(student) {
			return student.id === studentID;
		});
		showConfirmationDialog();
	};

	function showConfirmationDialog() {
		var scope = $rootScope.$new();
		scope.deleteStudents = self.deleteStudents;
		scope.cancel = self.cancel;
		scope.studentsToDelete = self.studentsToDelete;

		dxDialog.show({
			templateUrl: "tmpl/student/delete-students-popup.html",
			$scope: scope,
			escapeToClose: false,
			clickOutsideToClose: false,
		});
	}

	self.deleteStudents = function remove() {
		self.successDeletesCount = 0;
		self.rejectedDeletes = {};
		self.selectedAll = false;

		var studentIdsToDelete = self.studentsToDelete.map(function getId(s) {
			return s.id;
		});
		self.isLoading = true;
		self.isDeleting = true;

		dxApiV1Students.delete(studentIdsToDelete).then(function success(res) {
			if (res.data.hasOwnProperty("rejectedDeletions")) {
				res.data.rejectedDeletions.forEach(function forEachFn(reject) {
					var email; // Get the email from studentsToDelete
					self.studentsToDelete.find(function findFn(student) {
						if (student.id === reject.studentId) {
							email = student.email;
							return true;
						}
						return false;
					});

					self.rejectedDeletes[reject.studentId] = {
						email: email,
						status: reject.statusCode,
						error: reject.errorMessage,
					};
				});
			}

			self.students = self.students.filter(function filterFn(student) {
				if (student.id in self.rejectedDeletes) {
					if (self.rejectedDeletes[student.id].status === 405) {
						return false; // If they are no longer deletable, remove from list
					}
					return true;
				} else if (studentIdsToDelete.includes(student.id)) {
					delete self.selectedStudents[student.id];
					self.successDeletesCount += 1;
					return false;
				}
				return true;
			});


			// Without this recalcualtion, duplicate selection happens sometimes.
			calculateSelectedCount();

			// Fetch new content from the same query when delete is done then deselects the 'select all' input.
			self.isDeleting = false;
			self.studentsToDelete = [];
			self.selectedCount = 0;
			self.isLoading = false;
			self.searchInput = "";
			self.pageToken = null;
		}, function reject(res) {
			self.error = res.data.message;
			self.studentsToDelete = [];
		});

		dxDialog.closeMostRecent();
	};

	self.cancel = function cancel() {
		self.studentsToDelete = [];
		self.successDeletesCount = 0;
		self.rejectedDeletes = {};
		dxDialog.closeMostRecent();
	};

	self.isEmpty = function isEmpty(obj) {
		return Object.keys(obj).length === 0;
	};

	self.nextPage = function nextPage() {
		fetchDeletableStudents();
	};

	self.updateSort = function updateSort(predicate) {
		if (self.sortOptions.predicate === predicate) {
			self.sortOptions.reverse = !self.sortOptions.reverse;
		} else {
			self.sortOptions.predicate = predicate;
			self.sortOptions.reverse = false;
		}
		self.pageToken = null;
		self.error = null;
		self.students = [];
		self.selectedStudents = {};
		self.selectedAll = false;
		fetchDeletableStudents();
	};

	self.updateSearch = function updateSearch() {
		self.pageToken = null;
		self.error = null;
		self.students = [];
		self.selectedStudents = {};
		self.selectedAll = false;
		fetchDeletableStudents();
	};
});
